<script lang="ts">
    import type {TabButton, TabPageDefinitionsMap} from 'shared/ui-widgets/tabset/types';
    import {ErpTabbedSubpagesContainer, TabbedSubpagesRouter} from 'src/features/erp/components';
    import ProjectRecordDetailInfoTab from './tab-pages/ProjectRecordDetailInfoTab.svelte';
    import ProjectRecordDetailFinancialOverviewTab from './tab-pages/ProjectRecordDetailFinancialOverviewTab.svelte';
    import ProjectRecordDetailDebugTab from './tab-pages/ProjectRecordDetailDebugTab.svelte';

    const tabButtons: TabButton[] = [
        {
            id: 'tab-info',
            label: 'Základní informace',
            icon: 'info'
        },
        {
            id: 'tab-debug',
            label: 'Debug',
            icon: 'bug'
        },
        {
            id: 'tab-reported-work',
            label: 'Hospodaření zakázky',
            icon: 'edit'
        }
    ];

    const tabs: TabPageDefinitionsMap = {
        'tab-info': {component: ProjectRecordDetailInfoTab},
        'tab-reported-work': {component: ProjectRecordDetailFinancialOverviewTab},
        'tab-debug': {component: ProjectRecordDetailDebugTab}
    };
</script>

<ErpTabbedSubpagesContainer {tabButtons}
                            withoutUrlManagement
                            additionalClasses="sutor-project-detail"
                            let:activeTab>

    <TabbedSubpagesRouter {tabs} {activeTab}/>
</ErpTabbedSubpagesContainer>